
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/edit-passwords",
      function () {
        return require("private-next-pages/companies/edit-passwords.tsx");
      }
    ]);
  